import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actionCreator from '../../redux/actions/data-action';
import { ScreenContainer, ScreenNavigation } from './common';
import { Box, Button } from '@material-ui/core';
import { staticImages } from '../../assets/static-images';

class DemographicScreen extends Component {
	constructor(props) {
		super(props);

		this.state = {
			online: true,
			isLogout: false
		};

		this.onLogout = this.onLogout.bind(this);
		this.handleNext = this.handleNext.bind(this);
		this.updateOnlineStatus = this.updateOnlineStatus.bind(this);
	}

	componentDidMount() {
		const { history, resumeSession } = this.props;
		const resumeLocation = localStorage.getItem('resumeLocation');
		const resumeData = localStorage.getItem('resumeData');
		const resumeExpiry = parseInt(localStorage.getItem('resumeExpiry'));

		if (resumeLocation && resumeData) {
			if (resumeExpiry && new Date() > resumeExpiry) {
				localStorage.clear();
			} else {
				resumeSession(JSON.parse(resumeData));
				history.push(resumeLocation);
			}
		}

		window.addEventListener('online', this.updateOnlineStatus);
		window.addEventListener('offline', this.updateOnlineStatus);
		this.updateOnlineStatus();
	}
 
	componentWillUnmount() {
		if (this.state.isLogout) {
			this.props.clearUserData();
		}
	}

	onLogout() {
		this.setState({isLogout: true}, () => this.props.history.push('/Login'));
	}

	handleNext() {
		if (!this.state.online) {
			return;
		}
		const { history, data } = this.props;
		history.push(data.screens[0].url);
	}

	updateOnlineStatus() {
		this.setState({online: navigator.onLine});
	}

	render() {
		const { userData } = this.props.data;
		return (
			<>
				{!this.state.online && (
					<div className="popup-error">
						<div className="error-box">
							<img className="error-icon" width="100" height="90" src={staticImages.error} alt="Error" />
							<p className="error-text">Network connection lost: <br />Please contact your administrator.</p>
						</div>
					</div>
				)}
				<ScreenContainer>
					<Box className="demographic-header">
						<Button className="logout-button" onClick={this.onLogout}>LOGOUT</Button>
					</Box>
					<Box className="demographic-form">
						<p><span className="label">Student Name:</span> <strong>{userData.studentName}</strong></p>
						<p><span className="label">ID:</span> <strong>{userData.studentID == null ? "" : userData.studentID}</strong></p>
						<p><span className="label">Grade:</span> <strong>{userData.grade}</strong></p>
						<p><span className="label">School:</span> <strong>{userData.schoolBuilding}</strong></p>
						<p style={{float: 'right', fontSize: '8px'}}>Test SessionID: {userData.username}</p>
					</Box>
					<ScreenNavigation type="next" onClick={this.handleNext} />
				</ScreenContainer>
			</>
		);
	}
}

const mapStateToProps = state => ({
	data: state.data,
	tests: state.data.userData.tests
});

export default connect(mapStateToProps, actionCreator)(DemographicScreen);
